// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewCategorySkeleton-viewCategorySkeletonContainer-DHGFM {
    display: grid;
    grid-template-columns: 1fr 404px;
    gap: 24px;
    grid-gap: 24px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.ViewCategorySkeleton-viewCategorySkeletonImg-VSjhd {
    width: 100%;
    position: relative;
    height: 322px;
    border-radius: 18px 18px 0 0;
    background-color: var(--skeleton-secondary-bg);
}

.ViewCategorySkeleton-viewCategorySkeletonInfoContainer-j9Z0v {
    padding: 24px;
    background: var(--background-primary);
    border-radius: 0 0 18px 18px;
}

.ViewCategorySkeleton-viewCategorySkeletonTitle-S9_Yi {
    max-width: 90px;
    height: 30px;
    margin-bottom: 12px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.ViewCategorySkeleton-viewCategorySkeletonDesc-QibYM {
    max-width: 100%;
    height: 26px;
    margin-bottom: 3px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.ViewCategorySkeleton-viewCategorySkeletonSmallDesc-BrvCM {
    max-width: 138px;
    margin-bottom: 0;
}

.ViewCategorySkeleton-viewCategorySkeletonLink-b0770 {
    max-width: 102px;
    height: 26px;
    margin-top: 12px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.ViewCategorySkeleton-viewCategorySkeletonSearchContainer-TIswB {
    padding: 24px;
    background: var(--background-primary);
    border-radius: 18px;
}

.ViewCategorySkeleton-viewCategorySkeletonSearchTitle-YMOZw {
    max-width: 100%;
    height: 30px;
    margin-bottom: 18px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.ViewCategorySkeleton-viewCategorySkeletonLabel-Zq_Bq {
    max-width: 98px;
    height: 26px;
    margin-bottom: 6px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.ViewCategorySkeleton-viewCategorySkeletonInput-ABFTa {
    max-width: 100%;
    height: 44px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

@media (min-width: 1200px) {
    .ViewCategorySkeleton-viewCategorySkeletonRsBox-Ns6Pj {
        position: sticky;
        top: 100px;
    }
}

@media (max-width: 1199px) and (min-width: 992px) {
    .ViewCategorySkeleton-viewCategorySkeletonRsBox-Ns6Pj {
        position: sticky;
        top: 88px;
    }
}

@media (max-width: 991px) {
    .ViewCategorySkeleton-viewCategorySkeletonContainer-DHGFM {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
    }

    .ViewCategorySkeleton-viewCategorySkeletonLsBox-l5tZN {
        -webkit-box-ordinal-group: 3;
            -ms-flex-order: 2;
                order: 2;
        width: 100%;
    }

    .ViewCategorySkeleton-viewCategorySkeletonRsBox-Ns6Pj {
        -webkit-box-ordinal-group: 2;
            -ms-flex-order: 1;
                order: 1;
        width: 100%;
    }

    .ViewCategorySkeleton-viewCategorySkeletonInfoContainer-j9Z0v,
    .ViewCategorySkeleton-viewCategorySkeletonSearchContainer-TIswB {
        padding: 18px;
    }
}

@media (max-width: 767px) {
    .ViewCategorySkeleton-viewCategorySkeletonTitle-S9_Yi {
        height: 28px;
        margin-bottom: 6px;
    }

    .ViewCategorySkeleton-viewCategorySkeletonDesc-QibYM {
        height: 24px
    }

    .ViewCategorySkeleton-viewCategorySkeletonSearchTitle-YMOZw {
        height: 28px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Categories/ViewCategorySkeleton/ViewCategorySkeleton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,cAAc;IACd,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,4BAA4B;IAC5B,8CAA8C;AAClD;;AAGA;IACI,aAAa;IACb,qCAAqC;IACrC,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,oBAAa;QAAb,oBAAa;QAAb,aAAa;QACb,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,0BAAoB;YAApB,uBAAoB;gBAApB,oBAAoB;IACxB;;IAEA;QACI,4BAAQ;YAAR,iBAAQ;gBAAR,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,4BAAQ;YAAR,iBAAQ;gBAAR,QAAQ;QACR,WAAW;IACf;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".viewCategorySkeletonContainer {\n    display: grid;\n    grid-template-columns: 1fr 404px;\n    gap: 24px;\n    grid-gap: 24px;\n    align-items: flex-start;\n}\n\n.viewCategorySkeletonImg {\n    width: 100%;\n    position: relative;\n    height: 322px;\n    border-radius: 18px 18px 0 0;\n    background-color: var(--skeleton-secondary-bg);\n}\n\n\n.viewCategorySkeletonInfoContainer {\n    padding: 24px;\n    background: var(--background-primary);\n    border-radius: 0 0 18px 18px;\n}\n\n.viewCategorySkeletonTitle {\n    max-width: 90px;\n    height: 30px;\n    margin-bottom: 12px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.viewCategorySkeletonDesc {\n    max-width: 100%;\n    height: 26px;\n    margin-bottom: 3px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.viewCategorySkeletonSmallDesc {\n    max-width: 138px;\n    margin-bottom: 0;\n}\n\n.viewCategorySkeletonLink {\n    max-width: 102px;\n    height: 26px;\n    margin-top: 12px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.viewCategorySkeletonSearchContainer {\n    padding: 24px;\n    background: var(--background-primary);\n    border-radius: 18px;\n}\n\n.viewCategorySkeletonSearchTitle {\n    max-width: 100%;\n    height: 30px;\n    margin-bottom: 18px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.viewCategorySkeletonLabel {\n    max-width: 98px;\n    height: 26px;\n    margin-bottom: 6px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.viewCategorySkeletonInput {\n    max-width: 100%;\n    height: 44px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n@media (min-width: 1200px) {\n    .viewCategorySkeletonRsBox {\n        position: sticky;\n        top: 100px;\n    }\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n    .viewCategorySkeletonRsBox {\n        position: sticky;\n        top: 88px;\n    }\n}\n\n@media (max-width: 991px) {\n    .viewCategorySkeletonContainer {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .viewCategorySkeletonLsBox {\n        order: 2;\n        width: 100%;\n    }\n\n    .viewCategorySkeletonRsBox {\n        order: 1;\n        width: 100%;\n    }\n\n    .viewCategorySkeletonInfoContainer,\n    .viewCategorySkeletonSearchContainer {\n        padding: 18px;\n    }\n}\n\n@media (max-width: 767px) {\n    .viewCategorySkeletonTitle {\n        height: 28px;\n        margin-bottom: 6px;\n    }\n\n    .viewCategorySkeletonDesc {\n        height: 24px\n    }\n\n    .viewCategorySkeletonSearchTitle {\n        height: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewCategorySkeletonContainer": `ViewCategorySkeleton-viewCategorySkeletonContainer-DHGFM`,
	"viewCategorySkeletonImg": `ViewCategorySkeleton-viewCategorySkeletonImg-VSjhd`,
	"viewCategorySkeletonInfoContainer": `ViewCategorySkeleton-viewCategorySkeletonInfoContainer-j9Z0v`,
	"viewCategorySkeletonTitle": `ViewCategorySkeleton-viewCategorySkeletonTitle-S9_Yi`,
	"viewCategorySkeletonDesc": `ViewCategorySkeleton-viewCategorySkeletonDesc-QibYM`,
	"viewCategorySkeletonSmallDesc": `ViewCategorySkeleton-viewCategorySkeletonSmallDesc-BrvCM`,
	"viewCategorySkeletonLink": `ViewCategorySkeleton-viewCategorySkeletonLink-b0770`,
	"viewCategorySkeletonSearchContainer": `ViewCategorySkeleton-viewCategorySkeletonSearchContainer-TIswB`,
	"viewCategorySkeletonSearchTitle": `ViewCategorySkeleton-viewCategorySkeletonSearchTitle-YMOZw`,
	"viewCategorySkeletonLabel": `ViewCategorySkeleton-viewCategorySkeletonLabel-Zq_Bq`,
	"viewCategorySkeletonInput": `ViewCategorySkeleton-viewCategorySkeletonInput-ABFTa`,
	"viewCategorySkeletonRsBox": `ViewCategorySkeleton-viewCategorySkeletonRsBox-Ns6Pj`,
	"viewCategorySkeletonLsBox": `ViewCategorySkeleton-viewCategorySkeletonLsBox-l5tZN`
};
module.exports = ___CSS_LOADER_EXPORT___;
